"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.shouldDisplayTripJunction = exports.getDrivers = exports.getCurrentTripBirdDistanceMeters = exports.getBirdDistanceMeters = exports.deleteVisitedPlace = exports.formatTripDuration = exports.getShortcutVisitedPlaceName = exports.getShortcutVisitedPlacePerson = exports.getHouseholdVisitedAndUsualPlacesArrayAndByPersonId = exports.carsharingMembersCountInHousehold = exports.isWorker = exports.isStudent = exports.isStudentFromEnrolled = exports.selectNextIncompleteVisitedPlace = exports.allPersonsTripDiariesCompleted = exports.tripDiaryAndTravelBehaviorForPersonComplete = exports.shouldAskForNoSchoolTripReason = exports.shouldAskForNoWorkTripReason = exports.tripsForPersonComplete = exports.tripsIntroForPersonComplete = exports.householdMembersSectionComplete = exports.homeSectionComplete = exports.getHomeAddressOneLine = void 0;
const moment_business_days_1 = __importDefault(require("moment-business-days"));
const turf_1 = require("@turf/turf");
const LodashExtensions_1 = require("chaire-lib-common/lib/utils/LodashExtensions");
const project_config_1 = __importDefault(require("evolution-common/lib/config/project.config"));
const helpers_1 = require("evolution-common/lib/utils/helpers");
const odSurveyHelper = __importStar(require("evolution-common/lib/services/odSurvey/helpers"));
/**
 * Return the address as a one line string, including all the parts
 *
 * TODO Move to evolution
 * TODO2 Type the object here
 *
 * @param obj The object from which to extract address parts
 */
const getAddressOneLine = (obj, includeRegion = false, includeCountry = false, includePostalCode = false) => {
    if (!obj) {
        return '';
    }
    const civicNumberAndStreetName = obj.address;
    const city = obj.city;
    const region = obj.region;
    const country = obj.country;
    const postalCode = obj.postalCode;
    return !(0, LodashExtensions_1._isBlank)(civicNumberAndStreetName) && !(0, LodashExtensions_1._isBlank)(city)
        ? `${civicNumberAndStreetName}, ${city[0].toUpperCase() + city.substring(1)}${includeRegion && region ? `, ${region} ` : ''}${includeCountry && country ? `, ${country}` : ''}${includePostalCode && postalCode ? ' ' + postalCode.toUpperCase() : ''}`
        : '';
};
/**
 * Return the home address as a one line string, including all the parts
 *
 * TODO Move to evolution
 *
 * @param interview The interview
 */
const getHomeAddressOneLine = (interview, includeRegion = false, includeCountry = false, includePostalCode = false) => {
    const homeObj = (0, helpers_1.getResponse)(interview, 'home', undefined);
    return getAddressOneLine(homeObj, includeRegion, includeCountry, includePostalCode);
};
exports.getHomeAddressOneLine = getHomeAddressOneLine;
/**
 * Return whether the home section should be considered as completed
 *
 * TODO Parameterize the fields and conditions to check for the section in
 * Evolution instead of requiring this function
 *
 * @param interview
 * @returns
 */
const homeSectionComplete = (interview) => {
    const household = odSurveyHelper.getHousehold({ interview });
    const homeGeometry = (0, helpers_1.getResponse)(interview, 'home.geography.geometry.coordinates');
    return !((0, LodashExtensions_1._isBlank)(household) ||
        (0, LodashExtensions_1._isBlank)(household.size) ||
        (0, LodashExtensions_1._isBlank)(household.carNumber) ||
        (0, LodashExtensions_1._isBlank)(homeGeometry));
};
exports.homeSectionComplete = homeSectionComplete;
/**
 * Return whether the household members section should be considered as
 * completed
 *
 * TODO Parameterize the fields and conditions to check for the section in
 * Evolution instead of requiring this function
 * @param interview
 * @returns
 */
const householdMembersSectionComplete = (interview) => {
    if (!(0, exports.homeSectionComplete)(interview)) {
        return false;
    }
    const household = odSurveyHelper.getHousehold({ interview });
    const personCount = odSurveyHelper.countPersons({ interview });
    // FIXME If household size is less than person count, that's ok, we have
    // manually decremented, the participant should have gone to fix it in the
    // household section, if he did not and went directly to the trips (because
    // he already entered data further in the interview), we keep it as is. The
    // check used to be with !== but that prevent from completing the household
    // section when a member was manually added. Return to !==  when
    // https://github.com/chairemobilite/evolution/issues/1132 is fixed
    if (household.size > personCount) {
        return false;
    }
    const persons = odSurveyHelper.getPersonsArray({ interview });
    return persons.every((person) => basicInfoForPersonComplete(person, household.size));
};
exports.householdMembersSectionComplete = householdMembersSectionComplete;
// TODO Parameterize the fields and conditions to check for the section in
// Evolution instead of requiring this function
const basicInfoForPersonComplete = function (person, householdSize) {
    return !((0, LodashExtensions_1._isBlank)(person) ||
        (0, LodashExtensions_1._isBlank)(person.age) ||
        ((0, LodashExtensions_1._isBlank)(person.sexAssignedAtBirth) && (0, LodashExtensions_1._isBlank)(person.gender) && person.age >= 5) ||
        (householdSize > 1 && (0, LodashExtensions_1._isBlank)(person.nickname)) ||
        ((0, LodashExtensions_1._isBlank)(person.drivingLicenseOwnership) && person.age >= project_config_1.default.drivingLicenseAge));
};
/**
 * TODO Parameterize the fields and conditions to check for the section in
 * Evolution instead of requiring this function
 * @param person
 * @param interview
 * @returns
 */
const tripsIntroForPersonComplete = (person, interview) => {
    if (person && typeof person.age === 'number' && person.age < 5) {
        return true;
    }
    const journeys = odSurveyHelper.getJourneysArray({ person });
    if (journeys.length === 0) {
        return false;
    }
    const firstJourney = journeys[0];
    return (!(0, LodashExtensions_1._isBlank)(firstJourney.personDidTrips) &&
        (firstJourney.personDidTrips === 'no' || !(0, LodashExtensions_1._isBlank)(firstJourney.departurePlaceIsHome)));
};
exports.tripsIntroForPersonComplete = tripsIntroForPersonComplete;
const tripsForPersonComplete = function ({ person, interview }) {
    const journey = odSurveyHelper.getJourneysArray({ person })[0];
    // Complete if the person did not do any trips
    if (!(0, LodashExtensions_1._isBlank)(journey.personDidTrips) && journey.personDidTrips !== 'yes') {
        return true;
    }
    // Complete if there is no next trip or visited place to edit
    const visitedPlaces = odSurveyHelper.getVisitedPlacesArray({ journey });
    const nextPlace = (0, exports.selectNextIncompleteVisitedPlace)({ interview, visitedPlaces, person });
    const nextTrip = odSurveyHelper.selectNextIncompleteTrip({ journey });
    return nextTrip === null && nextPlace === null;
};
exports.tripsForPersonComplete = tripsForPersonComplete;
const getVisitedPlacesForCategory = (journey, activityCategory) => {
    const visitedPlaces = odSurveyHelper.getVisitedPlacesArray({ journey });
    return visitedPlaces.filter((visitedPlace) => visitedPlace.activityCategory === activityCategory);
};
const shouldAskForNoWorkTripReason = ({ person, interview }) => {
    // Ask only for all workers with fixed location
    const journey = odSurveyHelper.getJourneysArray({ person })[0];
    if (!person || !journey) {
        return false;
    }
    const workerType = person.workerType;
    const workPlaceType = person.workPlaceType;
    const workPlaceTypeIsCompatible = ['onLocation', 'onTheRoadWithUsualPlace', 'onTheRoadWithoutUsualPlace', 'hybrid'].includes(workPlaceType) &&
        ['fullTime', 'partTime'].includes(workerType);
    if (!workPlaceTypeIsCompatible) {
        return false;
    }
    const tripsDate = (0, helpers_1.getResponse)(interview, '_assignedDay', null);
    const tripsDateIsBusinessDay = (0, moment_business_days_1.default)(tripsDate).isBusinessDay();
    return tripsDateIsBusinessDay && getVisitedPlacesForCategory(journey, 'work').length === 0;
};
exports.shouldAskForNoWorkTripReason = shouldAskForNoWorkTripReason;
const shouldAskForNoSchoolTripReason = ({ person, interview }) => {
    // Ask only for full time students
    const journey = odSurveyHelper.getJourneysArray({ person })[0];
    if (!person || !journey) {
        return false;
    }
    const studentType = person.studentType;
    const schoolPlaceType = person.schoolPlaceType;
    const schoolPlaceIsCompatible = ['onLocation', 'hybrid'].includes(schoolPlaceType) && ['fullTime', 'partTime'].includes(studentType);
    const childrenCase = (0, exports.isStudentFromEnrolled)(person);
    if (!(schoolPlaceIsCompatible || childrenCase)) {
        return false;
    }
    const tripsDate = (0, helpers_1.getResponse)(interview, '_assignedDay', null);
    const tripsDateIsBusinessDay = (0, moment_business_days_1.default)(tripsDate).isBusinessDay();
    return tripsDateIsBusinessDay && getVisitedPlacesForCategory(journey, 'school').length === 0;
};
exports.shouldAskForNoSchoolTripReason = shouldAskForNoSchoolTripReason;
const travelBehaviorForPersonComplete = function ({ person, interview }) {
    // If the person is a child, we consider the travel behavior section as complete
    if (person && typeof person.age === 'number' && person.age < 5) {
        return true;
    }
    // If the person is not a student or worker, we consider the travel behavior section as complete
    if (person && !(0, exports.isStudent)(person) && !(0, exports.isWorker)(person)) {
        return true;
    }
    // Make sure the no trip reasons are answered if required
    const shouldAskNoSchoolTrip = (0, exports.shouldAskForNoSchoolTripReason)({ person, interview });
    const shouldAskNoWorkTrip = (0, exports.shouldAskForNoWorkTripReason)({ person, interview });
    if (!shouldAskNoSchoolTrip && !shouldAskNoWorkTrip) {
        return true;
    }
    const journey = odSurveyHelper.getJourneysArray({ person })[0];
    return ((!shouldAskNoSchoolTrip || typeof journey.noSchoolTripReason === 'string') &&
        (!shouldAskNoWorkTrip || typeof journey.noWorkTripReason === 'string'));
};
/**
 * TODO Parameterize the fields and conditions to check for the section in
 * Evolution instead of requiring this function
 * @param person
 * @param interview
 * @returns Whether the trip diary and travel behavior is finished
 */
const tripDiaryAndTravelBehaviorForPersonComplete = function (person, interview) {
    // FIXME Add conditions as sections are added
    return ((0, exports.tripsIntroForPersonComplete)(person, interview) &&
        (0, exports.tripsForPersonComplete)({ person, interview }) &&
        travelBehaviorForPersonComplete({ person, interview }));
};
exports.tripDiaryAndTravelBehaviorForPersonComplete = tripDiaryAndTravelBehaviorForPersonComplete;
/**
 * TODO Parameterize the fields and conditions to check for the section in
 * Evolution instead of requiring this function
 * @param interview
 * @returns
 */
const allPersonsTripDiariesCompleted = function (interview) {
    const interviewablePersons = odSurveyHelper.getInterviewablePersonsArray({ interview });
    return interviewablePersons.every((person) => (0, exports.tripDiaryAndTravelBehaviorForPersonComplete)(person, interview));
};
exports.allPersonsTripDiariesCompleted = allPersonsTripDiariesCompleted;
/**
 * Select the next incomplete visited place
 * TODO Parameterize the fields and conditions to check for the section in
 * Evolution instead of requiring this function
 * @param interview
 * @returns
 */
const selectNextIncompleteVisitedPlace = ({ interview, visitedPlaces, person }) => {
    const count = visitedPlaces.length;
    const lastVisitedlaces = visitedPlaces[visitedPlaces.length - 1];
    const lastSequence = lastVisitedlaces ? lastVisitedlaces._sequence : null;
    for (let i = 0; i < count; i++) {
        const visitedPlace = visitedPlaces[i];
        const nextVisitedPlace = visitedPlaces[i + 1];
        const geography = odSurveyHelper.getVisitedPlaceGeography({ visitedPlace, interview, person });
        if ((0, LodashExtensions_1._isBlank)(visitedPlace.activityCategory) ||
            (0, LodashExtensions_1._isBlank)(visitedPlace.activity) ||
            (visitedPlace._sequence === lastSequence &&
                visitedPlace.nextPlaceCategory !== 'stayedThereUntilTheNextDay') ||
            ((0, LodashExtensions_1._isBlank)(visitedPlace.arrivalTime) && visitedPlace._sequence > 1) ||
            ((0, LodashExtensions_1._isBlank)(visitedPlace.nextPlaceCategory) && !nextVisitedPlace) ||
            ((0, LodashExtensions_1._isBlank)(geography) && !['workOnTheRoad', 'leisureStroll'].includes(visitedPlace.activity))) {
            return visitedPlace;
        }
    }
    return null;
};
exports.selectNextIncompleteVisitedPlace = selectNextIncompleteVisitedPlace;
const isSchoolEnrolledTrueValues = [
    'kindergarten',
    'childcare',
    'primarySchool',
    'secondarySchool',
    'schoolAtHome',
    'other'
];
/**
 * Whether the person is enrolled in school
 * TODO Parameterize the fields and conditions to check for the section in
 * Evolution instead of requiring this function
 * @param person
 * @returns
 */
const isStudentFromEnrolled = (person) => {
    const schoolType = person.schoolType;
    return !(0, LodashExtensions_1._isBlank)(schoolType) && isSchoolEnrolledTrueValues.includes(schoolType);
};
exports.isStudentFromEnrolled = isStudentFromEnrolled;
/**
 * Whether the person is a student
 * TODO Parameterize the fields and conditions to check for the section in
 * Evolution instead of requiring this function
 * @param person
 * @returns
 */
const isStudent = (person) => {
    if ((0, LodashExtensions_1._isBlank)(person)) {
        return false;
    }
    return ['fullTimeStudent', 'partTimeStudent', 'workerAndStudent'].includes(person.occupation);
};
exports.isStudent = isStudent;
/**
 * Whether the person is a worker
 * @param person
 * @returns
 */
const isWorker = (person) => {
    if ((0, LodashExtensions_1._isBlank)(person)) {
        return false;
    }
    return ['fullTimeWorker', 'partTimeWorker', 'workerAndStudent'].includes(person.occupation);
};
exports.isWorker = isWorker;
/**
 * Get the number of car sharing members in the household
 * TODO Parameterize the fields and conditions to check for the section in
 * Evolution instead of requiring this function
 * @param interview
 * @returns
 */
const carsharingMembersCountInHousehold = (interview) => {
    const carSharingMembers = odSurveyHelper
        .getPersonsArray({ interview })
        .filter((person) => person.carSharingMember === 'yes');
    return carSharingMembers.length;
};
exports.carsharingMembersCountInHousehold = carsharingMembersCountInHousehold;
const getHouseholdVisitedAndUsualPlacesArrayAndByPersonId = function (interview) {
    const persons = odSurveyHelper.getPersonsArray({ interview });
    const visitedPlaces = [];
    const visitedPlacesByPersonId = {};
    const usualPlaces = [];
    const usualPlacesByPersonId = {};
    for (const person of persons) {
        // Get the person's usual places
        const personUsualPlaces = [];
        usualPlacesByPersonId[person._uuid] = personUsualPlaces;
        if (person.usualWorkPlace) {
            personUsualPlaces.push(Object.assign(Object.assign({}, person.usualWorkPlace), { activity: 'workUsual' }));
        }
        if (person.usualSchoolPlace) {
            personUsualPlaces.push(Object.assign(Object.assign({}, person.usualSchoolPlace), { activity: 'schoolUsual' }));
        }
        usualPlaces.push(...personUsualPlaces);
        usualPlacesByPersonId[person._uuid] = personUsualPlaces;
        // Get the person's visited places
        const personJourney = odSurveyHelper.getJourneysArray({ person })[0];
        if ((0, LodashExtensions_1._isBlank)(personJourney)) {
            continue; // Skip persons without journeys
        }
        const personVisitedPlacesArray = odSurveyHelper.getVisitedPlacesArray({ journey: personJourney });
        const visitedPlacesWithJourney = personVisitedPlacesArray.map((visitedPlace) => ({
            visitedPlace,
            journey: personJourney
        }));
        visitedPlaces.push(...visitedPlacesWithJourney);
        visitedPlacesByPersonId[person._uuid] = visitedPlacesWithJourney;
    }
    return {
        visitedPlaces,
        visitedPlacesByPersonId,
        usualPlaces,
        usualPlacesByPersonId
    };
};
exports.getHouseholdVisitedAndUsualPlacesArrayAndByPersonId = getHouseholdVisitedAndUsualPlacesArrayAndByPersonId;
const getShortcutVisitedPlacePerson = function (shortcutVisitedPlaceId, interview) {
    if (!shortcutVisitedPlaceId) {
        return null;
    }
    const visitedAndUsualPlacesArrayAndByPersonId = (0, exports.getHouseholdVisitedAndUsualPlacesArrayAndByPersonId)(interview);
    for (const personId in visitedAndUsualPlacesArrayAndByPersonId.visitedPlacesByPersonId) {
        const personVisitedPlacesAndJourney = visitedAndUsualPlacesArrayAndByPersonId.visitedPlacesByPersonId[personId];
        for (let i = 0, count = personVisitedPlacesAndJourney.length; i < count; i++) {
            const visitedPlace = personVisitedPlacesAndJourney[i];
            if (visitedPlace && visitedPlace.visitedPlace._uuid === shortcutVisitedPlaceId) {
                return odSurveyHelper.getPerson({ interview, personId });
            }
        }
    }
    // It may be one of the usual places
    for (const personId in visitedAndUsualPlacesArrayAndByPersonId.usualPlacesByPersonId) {
        const personVisitedPlaces = visitedAndUsualPlacesArrayAndByPersonId.usualPlacesByPersonId[personId];
        for (let i = 0, count = personVisitedPlaces.length; i < count; i++) {
            const visitedPlace = personVisitedPlaces[i];
            if (visitedPlace && visitedPlace._uuid === shortcutVisitedPlaceId) {
                return odSurveyHelper.getPerson({ interview, personId });
            }
        }
    }
    return null;
};
exports.getShortcutVisitedPlacePerson = getShortcutVisitedPlacePerson;
const getShortcutVisitedPlaceName = function (shortcutVisitedPlace, interview) {
    if (!shortcutVisitedPlace) {
        return null;
    }
    if (shortcutVisitedPlace.name) {
        return shortcutVisitedPlace.name;
    }
    else if (shortcutVisitedPlace.activity === 'home') {
        return null;
    }
    else if (shortcutVisitedPlace.activity === 'workUsual') {
        const person = (0, exports.getShortcutVisitedPlacePerson)(shortcutVisitedPlace._uuid, interview);
        return person.usualWorkPlaceName || null;
    }
    else if (shortcutVisitedPlace.activity === 'schoolUsual') {
        const person = (0, exports.getShortcutVisitedPlacePerson)(shortcutVisitedPlace._uuid, interview);
        return person.usualSchoolPlaceName || null;
    }
    return null;
};
exports.getShortcutVisitedPlaceName = getShortcutVisitedPlaceName;
const getDurationWithHourFromSeconds = function (durationSeconds) {
    if ((0, LodashExtensions_1._isBlank)(durationSeconds) || isNaN(Number(durationSeconds))) {
        return {
            hour: null,
            minute: null
        };
    }
    const hour = Math.floor(durationSeconds / 3600);
    const minute = Math.round(durationSeconds / 60) - hour * 60;
    return {
        hour,
        minute
    };
};
/**
 * Formats a trip duration as a presentable and localized string
 *
 * TODO Bring to evolution
 *
 * @param {number} startTime trip start time: number of seconds since midnight
 * @param {number} endTime trip end time: number of seconds since midnight
 * @param {string} language localization language: either 'fr' or 'en'.
 *
 * @return {string} the formatted trip duration. Ex: <span class="_pale _oblique">(déplacement de 2 heures 5 minutes)</span>
 */
const formatTripDuration = function (startTime, endTime, language) {
    if ((0, LodashExtensions_1._isBlank)(startTime) || (0, LodashExtensions_1._isBlank)(endTime)) {
        return '';
    }
    const travelTimeSeconds = startTime - endTime;
    const travelTimeHourAndMinute = getDurationWithHourFromSeconds(travelTimeSeconds);
    if (!(0, LodashExtensions_1._isBlank)(travelTimeHourAndMinute)) {
        const hour = travelTimeHourAndMinute.hour;
        const minute = travelTimeHourAndMinute.minute;
        // TODO: Do this localization with the i18n system properly. For now... flemme
        if (language === 'fr') {
            const travelTimeStr = travelTimeHourAndMinute
                ? `${hour > 0 ? ` ${hour} heure${hour >= 2 ? 's' : ''}` : ''}${hour === 0 && minute === 0 ? ' moins de 5 minutes' : minute > 0 ? ` ${minute} minutes` : ''}`
                : '';
            return `<br /><span class="_pale _oblique">(déplacement de${travelTimeStr})</span>`;
        }
        else {
            const travelTimeStr = travelTimeHourAndMinute
                ? `${hour > 0 ? `${hour} h` : ''}${hour === 0 && minute === 0
                    ? 'less than 5 min'
                    : minute > 0
                        ? `${hour > 0 ? ' ' : ''}${minute} min`
                        : ''}`
                : '';
            return `<br /><span class="_pale _oblique">(${travelTimeStr} trip)</span>`;
        }
    }
};
exports.formatTripDuration = formatTripDuration;
const updateVisitedPlaces = function (person, journey, visitedPlaces, includeSelectedVisitedPlaceId = true) {
    const count = visitedPlaces.length;
    const updateValuesByPath = {};
    for (let i = 0; i < count; i++) {
        const visitedPlace = visitedPlaces[i];
        const visitedPlacePath = `household.persons.${person._uuid}.journeys.${journey._uuid}.visitedPlaces.${visitedPlace._uuid}`;
        const nextVisitedPlace = i + 1 < count ? visitedPlaces[i + 1] : null;
        if (nextVisitedPlace &&
            nextVisitedPlace.activity === 'home' &&
            visitedPlace.nextPlaceCategory !== 'wentBackHome') {
            updateValuesByPath[`response.${visitedPlacePath}.nextPlaceCategory`] = 'wentBackHome';
        }
        if (nextVisitedPlace &&
            nextVisitedPlace.activity !== 'home' &&
            visitedPlace.nextPlaceCategory === 'wentBackHome') {
            updateValuesByPath[`response.${visitedPlacePath}.nextPlaceCategory`] = 'visitedAnotherPlace';
        }
        if (!nextVisitedPlace &&
            !(0, LodashExtensions_1._isBlank)(visitedPlace.nextPlaceCategory) &&
            visitedPlace.nextPlaceCategory !== 'stayedThereUntilTheNextDay') {
            // we need to nullify path for the previous visited place:
            updateValuesByPath[`response.${visitedPlacePath}.nextPlaceCategory`] = null;
        }
        if (i === 0 && !(0, LodashExtensions_1._isBlank)(visitedPlace.arrivalTime)) {
            updateValuesByPath[`response.${visitedPlacePath}.arrivalTime`] = null;
        }
        if (visitedPlace.nextPlaceCategory === 'stayedThereUntilTheNextDay' &&
            i === count - 1 &&
            !(0, LodashExtensions_1._isBlank)(visitedPlace.departureTime)) {
            updateValuesByPath[`response.${visitedPlacePath}.departureTime`] = null;
        }
        if (includeSelectedVisitedPlaceId) {
            updateValuesByPath['response._activeVisitedPlaceId'] = (0, exports.selectNextIncompleteVisitedPlace)(visitedPlaces);
        }
        return updateValuesByPath;
    }
};
/**
 * TODO Move to Evolution, this was copy pasted from there anyway
 * @param visitedPlacePath
 * @param interview
 * @param startRemoveGroupedObjects
 * @param startUpdateInterview
 * @returns
 */
const deleteVisitedPlace = (visitedPlacePath, interview, startRemoveGroupedObjects, startUpdateInterview) => {
    const person = odSurveyHelper.getPerson({ interview });
    const journey = odSurveyHelper.getActiveJourney({ interview });
    if (!journey) {
        return;
    }
    const visitedPlacePathsToDelete = [visitedPlacePath];
    const visitedPlace = (0, helpers_1.getResponse)(interview, visitedPlacePath, null);
    const previousVisitedPlace = odSurveyHelper.getPreviousVisitedPlace({
        visitedPlaceId: visitedPlace._uuid,
        journey
    });
    const nextVisitedPlace = odSurveyHelper.getNextVisitedPlace({ visitedPlaceId: visitedPlace._uuid, journey });
    if (nextVisitedPlace &&
        nextVisitedPlace.activity === 'home' &&
        previousVisitedPlace &&
        previousVisitedPlace.activity === 'home') {
        const nextVisitedPlacePath = `household.persons.${person._uuid}.journeys.${journey._uuid}.visitedPlaces.${nextVisitedPlace._uuid}`;
        visitedPlacePathsToDelete.push(nextVisitedPlacePath);
    }
    // Before deleting, replace the location shortcuts by original data, the will be updated after group removal
    const updatedValues = visitedPlacePathsToDelete
        .map((placePath) => odSurveyHelper.replaceVisitedPlaceShortcuts({ interview, shortcutTo: placePath }))
        .filter((updatedPaths) => updatedPaths !== undefined)
        .reduce((previous, current) => ({
        updatedValuesByPath: Object.assign(previous.updatedValuesByPath, current.updatedValuesByPath),
        unsetPaths: [...previous.unsetPaths, ...current.unsetPaths]
    }), { updatedValuesByPath: {}, unsetPaths: [] });
    startRemoveGroupedObjects(visitedPlacePathsToDelete, (updatedInterview) => {
        const person = odSurveyHelper.getPerson({ interview: updatedInterview });
        const journey = odSurveyHelper.getActiveJourney({ interview: updatedInterview, person });
        const visitedPlaces = odSurveyHelper.getVisitedPlaces({ journey });
        const updateValuesByPath = updateVisitedPlaces(person, journey, visitedPlaces, true);
        startUpdateInterview({
            sectionShortname: 'visitedPlaces',
            valuesByPath: Object.assign(updatedValues.updatedValuesByPath, updateValuesByPath),
            unsetPaths: updatedValues.unsetPaths
        });
    });
};
exports.deleteVisitedPlace = deleteVisitedPlace;
/**
 * Get the distance in meters between the origin and destination of a trip
 * TODO Move to Evolution
 */
const getBirdDistanceMeters = function ({ trip, visitedPlaces, person, interview }) {
    const origin = odSurveyHelper.getOrigin({ trip, visitedPlaces });
    const destination = odSurveyHelper.getDestination({ trip, visitedPlaces });
    if ((0, LodashExtensions_1._isBlank)(origin) || (0, LodashExtensions_1._isBlank)(destination)) {
        return null;
    }
    const originGeography = odSurveyHelper.getVisitedPlaceGeography({ visitedPlace: origin, interview, person });
    const destinationGeography = odSurveyHelper.getVisitedPlaceGeography({
        visitedPlace: destination,
        interview,
        person
    });
    if ((0, LodashExtensions_1._isBlank)(originGeography) || (0, LodashExtensions_1._isBlank)(destinationGeography)) {
        return null;
    }
    return (0, turf_1.distance)(originGeography.geometry, destinationGeography.geometry, {
        units: 'meters'
    });
};
exports.getBirdDistanceMeters = getBirdDistanceMeters;
const getCurrentTripBirdDistanceMeters = ({ interview }) => {
    const person = odSurveyHelper.getActivePerson({ interview });
    const journey = odSurveyHelper.getActiveJourney({ interview });
    const visitedPlaces = odSurveyHelper.getVisitedPlaces({ journey });
    const trip = odSurveyHelper.getActiveTrip({ interview, journey });
    return (0, exports.getBirdDistanceMeters)({ trip, visitedPlaces, person, interview });
};
exports.getCurrentTripBirdDistanceMeters = getCurrentTripBirdDistanceMeters;
/**
 * TODO Move to Evolution
 */
const getDrivers = ({ interview }) => {
    const persons = odSurveyHelper.getPersonsArray({ interview });
    return persons.filter((person) => person.drivingLicenseOwnership === 'yes');
};
exports.getDrivers = getDrivers;
/**
 * TODO Move to Evolution
 * TODO Parameterize the modes here, this function is copy-pasted as is from 2024
 */
const shouldDisplayTripJunction = (previousSegment, currentSegment, activity) => {
    //tripJunction needed when changing from private to public modes (private modes: car driver, car passenger, moto, taxi - walking is excluded )
    if (!(0, LodashExtensions_1._isBlank)(previousSegment) &&
        (['carDriver', 'carPassenger', 'bicycle', 'taxi', 'train', 'paratransit'].includes(previousSegment.modePre) ||
            [
                'taxi',
                'ferryWithCar',
                'motorcycle',
                'bicycle',
                'bicycleElectric',
                'kickScooterElectric',
                'plane',
                'other'
            ].includes(previousSegment.mode)) &&
        (currentSegment.modePre === 'transit' ||
            ['ferryNoCar', 'ferryNoCar', 'train', 'intercityBus', 'taxi'].includes(currentSegment.mode))) {
        return activity !== 'workOnTheRoad';
    }
    if (!(0, LodashExtensions_1._isBlank)(previousSegment) &&
        (['carDriver', 'carPassenger', 'bicycle', 'taxi', 'train', 'paratransit'].includes(currentSegment.modePre) ||
            [
                'taxi',
                'ferryWithCar',
                'motorcycle',
                'bicycle',
                'bicycleElectric',
                'kickScooterElectric',
                'plane',
                'other'
            ].includes(currentSegment.mode)) &&
        (previousSegment.modePre === 'transit' ||
            ['transitBus', 'ferryNoCar', 'train', 'intercityBus', 'taxi'].includes(previousSegment.mode))) {
        return activity !== 'workOnTheRoad';
    }
    return false;
};
exports.shouldDisplayTripJunction = shouldDisplayTripJunction;
